import Service from 'react-reservice';

import { AxiosResponse } from '@webtrader/core/request';

interface IMaintenanceContext {
  underMaintenance?: boolean;
}

class MaintenanceService extends Service<IMaintenanceContext> {
  constructor() {
    super();
  }

  public checkForMaintenance = (response: AxiosResponse) => {
    if (typeof response.data === 'string' && response.data.includes('Under Maintenance')) {
      this.context.underMaintenance = true;
    }
  };
}

export default new MaintenanceService();
